export default __webpack_public_path__ + "static/media/fact-checker-s1.994dd7d7.png";